import { Injectable } from '@angular/core';
import { TableDatasource } from '@core/api/table.datasource';
import { appConfig } from '@core/app-config';
import {
  DokumentAfsendelseSearchParams
} from '@features/dokumenter/afsendelse/dokument-afsendelse-search/dokument-afsendelse-search-params.model';
import { DokumentAfsendelse } from '@features/dokumenter/afsendelse/dokument-afsendelse.model';

@Injectable({
  providedIn: 'root',
})
export class DokumentAfsendelseDatasource extends TableDatasource<
  DokumentAfsendelse,
  DokumentAfsendelseSearchParams
> {
  endpoint = '/api/admin/dokumenterafsendelse';
  defaultSortField = 'id';
  override defaultDescending = true;

  async gensend(ids: number[]) {
    const url = `${appConfig.apiRoot}${this.endpoint}/gensend`;
    const options = await this.getOptions();
    options.method = 'POST';
    options.body = JSON.stringify(ids);
    return await this.fetchSingle(url, options);
  }
}
